export { featureFlagsPlugin, resourceTimingsPlugin, customPerfMarks } from './browser-metrics-v3-plugins';
